/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { Button, Tooltip } from 'antd';
import { useTheme } from '../ThemeContext';
import styles from './styles.module.css';

const ThemeToggle = (t) => {
  const { theme, toggleTheme } = useTheme(t);

  return (
    <Tooltip
      title={theme === 'light' ? 'Enable dark theme' : 'Enable light theme'}
      placement="bottom"
    >
      <Button
        onClick={toggleTheme}
        className={styles.themeToggle}
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      >
        {theme === 'light' ? '🌙' : '☀️'}
      </Button>
    </Tooltip>
  );
};

export default ThemeToggle;
